import React from "react";
import "./PlanetCard.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
function PlanetCard() {
  const { t, i18n } = useTranslation();
  const logo = useSelector((state: any) => state.auth.customerLogo);
  const planetwiseLogo = "assets/images/planetwise-new-logo.png";
  const isSupplierPage = window.location.pathname.includes("register-supplier");
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const logoKey = queryParameters.get("ref") || location.state?.ref || "";
  const logoMap: any = {
    ccc: "assets/images/ccc-logo-dark.png",
    cii: "assets/images/cii-logo.png",
  };

  return (
    <div className="pw-bg flex flex-col pw-position-relative">
      <img
        className="h-full flex"
        // src={PUBLIC_URL+'assets/images/bg-auth.png'}
        src="assets/images/bg-onboarding.png"
        alt="background"
      />
      <div
        className="pw-position-absolute pw-bg-content items-start flex flex-col w-6/10"
        style={{ height: "100vh" }}
      >
        <div style={{ position: "absolute", right: "20px", top: "20px" }}>
          <img
            className="h-28"
            src="assets/images/GRI-LP-2025.png"
            alt="gri-logo"
          />
        </div>
        {logoKey ? (
          <div style={{ position: "absolute", right: "150px", top: "20px" }}>
            <img className="h-28" src={logoMap[logoKey]} alt="ref-logo" />
          </div>
        ) : (
          ""
        )}
        <img
          className="h-full flex pw-comp-icon-onboarding"
          src={logo ? logo : planetwiseLogo}
          alt="background"
        />
        <div className="flex flex-col">
          <div className="text-neutral-700 pw-desc-title">
            We Make Carbon Visible
          </div>
        </div>

        <div className="pw-desc flex flex-1 mt-5 text-neutral-700">
          Join us and embark on a journey towards sustainable change. Start
          managing your carbon footprint now, taking the first step to make a
          positive impact on our planet with us
        </div>
        {isSupplierPage ? (
          <div className="flex items-center">
            Powered by planetwise{" "}
            <img
              className="flex"
              style={{ marginLeft: "20px", height: "5vh" }}
              src={planetwiseLogo}
              alt="background"
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default PlanetCard;
